import { MatTableDataSource } from '@angular/material/table';
import { AfterViewInit, Component, DestroyRef, Inject, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ServicesService } from 'src/services/services.service';
import { MatSort } from '@angular/material/sort';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import { SocketService } from 'src/services/socket.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

export interface EventElement {
  id: string;
  mem_id: string;
  name: string;
  mobile: string;
  transaction_id: any;
  order_id: any;
  amount: any;
  status: any;
  mode: any;
  date: any;
  coupon_code: any;
}

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent {
  displayedColumns: string[] = [
    'id',
    'mem_id',
    'status',
    'amount',
    'name',
    'mobile',
    'transaction_id',
    'order_id',
    'mode',
    'coupon_code',
    'date',
  ];

  ELEMENT_DATA: EventElement[] = [];
  private destoryRef = inject(DestroyRef);
  dataSource = new MatTableDataSource<EventElement>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  event_result: any;
  event_id: any;

  constructor(
    private service: ServicesService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private router: Router,
    private location: Location,
    private socketservice: SocketService
  ) { }

  ngOnInit() {
    this.event_id = window.sessionStorage.getItem('Event_ID');
    this.Get_Report();
  }

  back() {
    this.router.navigate(['/admin/Reports']);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  Get_Report() {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.gettransactions(this.event_id).pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.event_result = data.data
        for (const item of this.event_result) {
          this.ELEMENT_DATA.push({
            id: item.id,
            mem_id: item.mem_id,
            name: item.name,
            mobile: item.mobile,
            transaction_id: item.transaction_id,
            order_id: item.order_id,
            status: item.status,
            amount: item.amount,
            mode: item.mode,
            date: item.date,
            coupon_code: item.coupon_code
          });
          this.spinner.hide();
        }

        this.dataSource = new MatTableDataSource<EventElement>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }
  getPaymentClass(status: string): string {
    console.log(status);

    switch ((status || '').toLowerCase()) {
      case 'captured':
        return 'pay-captured';

      case 'failed':
        return 'pay-failed';

      case 'in_progress':
      case 'in progress':
        return 'pay-progress';

      default:
        return 'pay-unknown';
    }
  }

}
